<template>
  <div>
    <el-tabs v-model="active" type="border-card">
      <el-tab-pane label="在途订单" name="A">
        <all-table v-if="active === 'A'" />
      </el-tab-pane>
      <el-tab-pane label="待提货" name="B">
        <pick-table v-if="active === 'B'" />
      </el-tab-pane>
      <el-tab-pane label="待送达" name="C">
        <delivery-table v-if="active === 'C'" />
      </el-tab-pane>
      <el-tab-pane label="待回单" name="D">
        <pod-table v-if="active === 'D'" />
      </el-tab-pane>
      <el-tab-pane label="回单待审核" name="E">
        <apply-table v-if="active === 'E'" />
      </el-tab-pane>
      <el-tab-pane label="待完成" name="F">
        <confirmed-table v-if="active === 'F'" />
      </el-tab-pane>
      <el-tab-pane label="已完成" name="G">
        <finish-table v-if="active === 'G'" />
      </el-tab-pane>
      <el-tab-pane label="异常事件" name="H">
        <exc-table v-if="active === 'H'" />
      </el-tab-pane>
      <el-tab-pane label="特殊费用" name="I">
        <fee-table v-if="active === 'I'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AllTable from './components/all-table'
import PickTable from './components/to-pick-table'
import DeliveryTable from './components/to-delivery-table'
import PodTable from './components/to-pod-table'
import ApplyTable from './components/pod-to-apply-table'
import ConfirmedTable from './components/pod-confirmed-table'
import FinishTable from './components/finish-table'
import ExcTable from './components/exc-table'
import FeeTable from './components/fee-table'
import BaseTable from '@/mixins/base-table'
export default {
  name: 'carriage-tracking',
  components: {
    AllTable,
    PickTable,
    DeliveryTable,
    PodTable,
    ApplyTable,
    ConfirmedTable,
    FinishTable,
    ExcTable,
    FeeTable,
  },
  mixins: [BaseTable],
  data() {
    return {
      active: 'A',
    }
  },
  activated() {
    this.displayPage()
  },
  methods: {
    displayPage() {
      if (this.$route.params.active) {
        this.active = this.$route.params.active
      } else {
        return
      }
    },
  },
}
</script>
